export enum StatsElementMapSimpleGridBlock {
  Root = 'StatsElementMapSimpleGrid',
}
